// The "Shift" marker on derived shift entries (architecture sprint-13 §12): entry cards, Records rows and
// project entry lists. Read-only: shift time is corrected on the shift, never edited as an entry.
import { SHIFT_ENTRY_LABEL } from '@shared/shifts';
import { Clock4 } from 'lucide-react';

export function ShiftBadge(): JSX.Element {
  return (
    <span className="inline-flex items-center gap-1 text-xs text-muted-foreground" title="Shift time. Ask an Admin to correct the shift.">
      <Clock4 className="h-3 w-3" aria-hidden="true" />
      {SHIFT_ENTRY_LABEL}
    </span>
  );
}
